/*
 * LBL policy pages (client, 4 Nov): the policies were pasted from Word, so tidy them and add an "On this page" side nav.
 * Shopify renders the policy body itself, which is why this runs in the browser rather than in a template.
 */
(() => {
  const container = document.querySelector('.shopify-policy__container');
  const body = container?.querySelector('.shopify-policy__body .rte');
  if (!body) return;

  // Shopify fixes policy titles; the client calls this one "Returns, Refunds & Cancellations Policy" (the <title> is set in theme.liquid)
  if (location.pathname.endsWith('/policies/refund-policy')) {
    const h1 = container.querySelector('.shopify-policy__title h1');
    if (h1) h1.textContent = 'Returns, Refunds & Cancellations Policy';
  }

  // Word "bullets" are paragraphs (class MsoListParagraph…) starting with a Symbol-font dot or a number: make real lists
  let list = null;
  [...body.children].forEach((el) => {
    if (!(el.tagName === 'P' && /^MsoListParagraph/.test(el.className))) { list = null; return; }
    const marker = el.querySelector('span[style*="Symbol"], span[style*="mso-list"]') || el.firstElementChild;
    const markerText = marker?.textContent.replace(/\s+/g, ' ').trim() || '';
    const ordered = /^\(?[0-9a-z]{1,3}[.)]$/i.test(markerText);
    // a bullet marker has no letters or digits (Word's second-level bullet is a plain 'o')
    if (marker && (ordered || markerText === 'o' || !/[\p{L}\p{N}]/u.test(markerText))) marker.remove();
    if (!list || list.tagName !== (ordered ? 'OL' : 'UL')) {
      list = document.createElement(ordered ? 'ol' : 'ul');
      el.before(list);
    }
    const li = document.createElement('li');
    li.append(...el.childNodes);
    list.append(li);
    el.remove();
  });

  // Word spacing styles: keep the tight lines (contact details), drop the rest so the theme's spacing applies
  body.querySelectorAll('[style]').forEach((el) => {
    if (/margin-bottom:\s*0/.test(el.getAttribute('style'))) el.classList.add('lbl-policy__tight');
    el.removeAttribute('style');
  });
  body.querySelectorAll('p').forEach((p) => { if (!p.textContent.trim() && !p.querySelector('img')) p.remove(); });

  // Side nav from the most used heading level (some policies use one h2 title then h3 sections)
  const pick = ['h2', 'h3'].map((tag) => [...body.querySelectorAll(tag)]).sort((a, b) => b.length - a.length)[0];
  if (pick.length < 3) return;
  const nav = document.createElement('nav');
  nav.className = 'lbl-policy__nav';
  nav.setAttribute('aria-label', 'On this page');
  const details = document.createElement('details');
  details.open = window.matchMedia('(min-width: 1024px)').matches;
  details.innerHTML = '<summary>On this page</summary>';
  const ol = document.createElement('ol');
  pick.forEach((h, i) => {
    h.id ||= `section-${i + 1}-${h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')}`;
    const a = document.createElement('a');
    a.href = `#${h.id}`;
    a.textContent = h.textContent.trim();
    const li = document.createElement('li');
    li.append(a);
    ol.append(li);
  });
  details.append(ol);
  nav.append(details);
  container.classList.add('lbl-policy');
  container.querySelector('.shopify-policy__body').before(nav);

  // Mark the section in view
  const links = new Map([...ol.querySelectorAll('a')].map((a) => [a.hash.slice(1), a]));
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      links.forEach((a) => a.removeAttribute('aria-current'));
      links.get(entry.target.id)?.setAttribute('aria-current', 'true');
    });
  }, { rootMargin: '0px 0px -70% 0px' });
  pick.forEach((h) => observer.observe(h));
})();
